import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

export default class Modal extends React.Component {
    render() {
        return (
            <CSSTransitionGroup
                transitionName="example"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}>
                {this.props.modalShowing && this.props.children}
            </CSSTransitionGroup>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/Modal.jsx